import React from 'react';
import OvpCalendarIcon from '../../../assets/OVPCalendarIcon';
import BankIcon from '../../../assets/BankIcon';

import {
  MessageWrapper,
  IconWrapper,
  Details,
  Info,
  SubTitle,
} from './MessageTile.styles';

const MessageTile = ({ message }: any) => {
  const { imageType, info, subTitle } = message;

  const Images: any = {
    calendar: <OvpCalendarIcon />,
    bank: <BankIcon />,
  };

  return (
    <MessageWrapper>
      {/* <IconWrapper>{Images[imageType]}</IconWrapper> */}
      <Details data-testid={`loan-card-details-body-${subTitle.replace(' ', '-')}`}>
        <Info
          data-testid={`loan-card-details-body-${subTitle.replace(' ', '-')}-value`}
        >
          {info}
        </Info>
        <SubTitle
          data-testid={`loan-card-details-body-${subTitle.replace(' ', '-')}-title`}
        >
          {subTitle}
        </SubTitle>
      </Details>
    </MessageWrapper>
  );
};

export default MessageTile;
